import { ColorPaletteProp } from '@healthinal/ui';
import { differenceInMilliseconds } from 'date-fns';
import { getAppointmentStartDateTime } from '../api/created/appointment.ts';
import { AppointmentDto, AppointmentDtoType } from '../api/generated/model';

export function getAppointmentTypeName(type: AppointmentDtoType) {
  switch (type) {
    case AppointmentDtoType.BLOOD_SAMPLING:
      return 'Bluttest';
    case AppointmentDtoType.XRAY:
      return 'Röntgen';
    case AppointmentDtoType.SPUTUM:
      return 'Sputum';
    case AppointmentDtoType.TUBERCULIN:
      return 'Tuberkulin';
    case AppointmentDtoType.OTHER:
      return 'Extern';
  }
}

export function getAppointmentTypeColor(type: AppointmentDtoType): ColorPaletteProp {
  switch (type) {
    case AppointmentDtoType.BLOOD_SAMPLING:
      return 'danger';
    case AppointmentDtoType.XRAY:
      return 'success';
    case AppointmentDtoType.SPUTUM:
      return 'primary';
    case AppointmentDtoType.TUBERCULIN:
      return 'warning';
    default:
      return 'neutral';
  }
}

export function getLatestAppointment(appointments: AppointmentDto[]) {
  if (!appointments.length) return undefined;

  return appointments.reduce(
    (latest, current) =>
      differenceInMilliseconds(getAppointmentStartDateTime(current) ?? '', getAppointmentStartDateTime(latest) ?? '') >
      0
        ? current
        : latest,
    appointments[0],
  );
}
